import React from "react";
import assets from "../../../../shared/constants/assetVariables";

function FeatureFour() {
  return (
    <section className="net-zero-feature-section">
      <div className="net-zero-feature-container">
        <div className="net-zero-feature-wrapper">
          <div className="net-zero-feature-image-wrapper">
            <div className="net-zero-feature-image">
              <img src={assets.images.reportingImage1} alt="updapt" />
            </div>
          </div>
          <div className="net-zero-feature-content-wrapper">
            <div className="net-zero-feature-content">
              <h2 className="net-zero-feature-title">
                Global Climate Change Reporting
              </h2>
              <p className="net-zero-feature-description">
                Report comparable and credible metrics and disclosures using an
                efficient reporting system aligned with globally adopted
                up-to-date climate change standards such as SECR, TCFD, CDP, etc
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeatureFour;
